import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';
import { LoginModule } from './login.module';
import { OtpComponent } from './otp/otp.component';
import { ResetPasswordComponent } from './resetpassword/resetpassword.component';
import { ResetpasswordFormComponent } from './resetpassword-form/resetpassword-form.component';
import { SignUpComponent } from './signup/signup.component';
import { OtpGuard } from 'src/app/services/helpers/otp.guard';
import { LoginFormComponent } from './login-form/login-form.component';

const routes: Routes = [
  { path: '', component: LoginComponent, children:[
    {path:'',component:LoginFormComponent},
    { path: 'reset-password', component: ResetPasswordComponent },
    { path: 'register', component: SignUpComponent },
    { path: 'otp/reset', component: OtpComponent, canActivate:[OtpGuard] },
    { path: 'password/reset', component: ResetpasswordFormComponent, canActivate:[OtpGuard] }
  ] },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
